export default __webpack_public_path__ + "static/media/massacorp.c19fb89e.svg";